<template>
    <div style="padding-bottom: 65px; box-sizing: border-box">
        <div style="display: flex; align-items: center; flex-wrap: wrap; justify-content: space-between">
            <div style="display: flex; align-items: center; flex-wrap: wrap; padding-left: 10px; box-sizing: border-box">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="prev == null ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : firstPage()"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="prev == null ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : prevPage()"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="next == null ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : nextPage()"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="next == null ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : lastPage()"
                />
            </div>
            <div style="display: flex; align-items: center; flex-wrap: wrap">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                    >{{ $t('common.add') }}</el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delCurry"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isedit" plain @click="isEdit(form.check)">{{
                    form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                }}</el-button>
            </div>
        </div>
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="top_cols">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billNo') + '：'">
                            <el-input v-model="form.trans_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billDate') + '：'" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.trans_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item :label="$t('common.billType') + '：'" required>
                            <el-select
                                v-model="form.billtype_no"
                                filterable
                                default-first-option
                                clearable
                                @visible-change="getRefreshPull()"
                                @change="refreshs()"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.billtype"
                                    :key="index"
                                    :label="item.billtype_no + ' - ' + item.billtype_name"
                                    :value="item.billtype_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.customer') + '：'" required>
                            <el-select
                                v-model="form.cust_no"
                                filterable
                                default-first-option
                                clearable
                                @visible-change="getRefreshPull()"
                                @change="selectCust"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in pull_cust"
                                    :key="index"
                                    :label="item.cust_no + ' - ' + item.cust_name"
                                    :value="item.cust_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.salesman') + '：'">
                            <el-select
                                v-model="form.salesman_no"
                                filterable
                                default-first-option
                                clearable
                                @visible-change="getRefreshPull()"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.salesman"
                                    :key="index"
                                    :label="item.salesman_no + ' - ' + item.salesman_name"
                                    :value="item.salesman_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 12 : 18">
                        <el-form-item :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div style="position: relative; margin-bottom: 10px">
            <!-- 明细 -->
            <div class="table1" @mouseleave="dtlleave">
                <div class="title">
                    <div style="text-align: left; color: #000; font-size: 16px; padding: 6px 0">
                        转换明细<span style="font-size: 12px; color: #666">（注意：正数为欠钱、负数为存钱）</span>
                    </div>
                </div>
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"
                    ref="xTable1"
                    :auto-resize="true"
                    height="440"
                    show-overflow
                    :footer-method="footerMethod"
                    show-footer
                    highlight-hover-row
                    :loading="loading"
                    :edit-rules="validRules"
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                    :row-class-name="rowChange"
                    :data="form.dtl"
                    :mouse-config="{ selected: true }"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                    @cell-mouseenter="dtlenter"
                    :key="refushTable"
                >
                    <vxe-table-column type="seq" field="seq" width="70" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                                <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                                <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                            </span>
                            <span v-if="scoped.$rowIndex != dtlIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="item.column_status == 1 && item.column_type != 'select' && item.field != 'amt'"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type)"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[processField(item.field)],
                                        `${processField(item.field)}_no`,
                                        `${processField(item.field)}_name`
                                    )
                                }}</span>
                            </template>

                            <template #edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, processField(item.field))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[processField(item.field)] || []"
                                        :key="option[`${processField(item.field)}_no`]"
                                        :label="`${option[`${processField(item.field)}_no`]} - ${
                                            option[`${processField(item.field)}_name`]
                                        }`"
                                        :value="option[`${processField(item.field)}_no`]"
                                        :disabled="option.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :key="item.field + index"
                            title="金额"
                            v-if="item.field == 'amt' && item.column_status == 1"
                            field="amt"
                            :width="item.column_width"
                            :edit-render="{}"
                        >
                            <template v-slot:edit="{ row }">
                                <span>{{ countAmount(row).toFixed(systemSet.amt) }}</span>
                            </template>
                        </vxe-table-column>
                    </template>
                    <template #empty>
                        <span style="color: red">
                            <img src="@/assets/img/dontHave.png" style="width: 200px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="原金额：">
                        <p>{{ form.oldamt }}</p>
                    </el-form-item>

                    <el-form-item label="金额：">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.trans_no)" style="width: 73px">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItCurrency">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 导出弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.export')" :visible.sync="excelData.isshow" width="60%">
            <div class="pro" style="text-align: center">
                <el-select
                    style="display: block; width: 50%; margin: 0 auto"
                    v-model="excelValue"
                    clearable
                    default-first-option
                    placeholder="请选择"
                >
                    <el-option label="货币转换" value="货币转换">货币转换</el-option>
                    <el-option label="货币转换明细" value="货币转换明细">货币转换明细</el-option>
                </el-select>
                <el-input style="display: block; width: 50%; margin: 10px auto" v-model="keyword" placeholder="请输入币转单号"></el-input>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="cust_no"
                    v-if="excelValue == '货币转换'"
                    placeholder="请选择客户"
                >
                    <el-option
                        v-for="(item, index) in allArr.cust"
                        :disabled="item.status == 0"
                        :key="index"
                        :label="item.cust_name"
                        :value="item.cust_no"
                    ></el-option>
                </el-select>
                <el-input
                    style="display: block; width: 50%; margin: 10px auto"
                    v-if="excelValue == '货币转换明细'"
                    v-model="oldamt"
                    placeholder="请输入原币金额"
                ></el-input>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="oldcurrency_no"
                    v-if="excelValue == '货币转换明细'"
                    placeholder="请选择原货币"
                >
                    <el-option
                        v-for="(item, index) in allArr.currency"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="atrans_no"
                    v-if="excelValue == '货币转换明细'"
                    placeholder="请选择转换方式"
                >
                    <el-option
                        v-for="(item, index) in allArr.atrans_no"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '货币转换'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="trans_date"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <div style="display: flex; align-items: center; margin-top: 30px; justify-content: center">
                    <el-button style="margin-left: 10px" type="success" icon="el-icon-download" @click="outExcel">{{ $t('common.export') }}</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="outTem">模板导出</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="excelData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiFirstCurrency,
    apiSearchCurrency,
    apiLastCurrency,
    apiNextCurrency,
    apiGetinfo,
    apiPrevCurrency,
    apiAllSelectCurrency,
    apiModifyCurrency,
    apiaddCurrency,
    apiDelCurrency,
    apiCurrentPermisson,
    apicheckCurrency,
    apichooseCurrency,
    apiAdjustinfo,
    apiSystem,
    apiCurrencyAllCheck,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'currencytransform',
    data() {
        return {
            bonusData: { field: [], table: [], condition: [], parameter: [] },
            tableIndex: 0,
            tableNo: 0,
            searchData: [],
            arr: [],
            arrs: [],
            cust_no: '',
            oldcurrency_no: '',
            atrans_no: '',
            trans_date: '',
            oldamt: '',
            tableData: [],
            activeName: 'first',
            allArr: '',
            form: {},
            isedit: true,
            isCheck: false,
            prev: null,
            next: null,
            outData: { isshow: false, scope: null, index: 0, data: {} },
            excelData: { isshow: false, scope: null, index: 0, data: {} },
            checkData: { isshow: false, scope: null, index: 0, data: {} },
            keyword: '',
            isAdd: false,
            loading: false,
            excelValue: '',
            pull_cust: [],
            pull_trans: [],
            nullBtn: false,
            systemSet: '',
            validRules: {
                oldcurrency_no: [{ required: true, message: '原币种必须填写' }],
                currency_no: [{ required: true, message: '转成币种必须填写' }]
            },
            username: '',
            dtlIndex: '-1',
            isSave: true,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '43',
            perData: {} //权限
        };
    },
    mounted() {
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    created() {
        if (this.$route.query.isadd == 0) {
            // this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            } else {
                this.geData();
            }
        }
        this.getStoneData();
        this.getTable();
        this.getPermission();
        this.getSystem();
        document.addEventListener('keydown', this.mykeyup);
    },
    activated() {
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.searchIt(bill_no);
        }
    },

    methods: {
        processField(field) {
            // 去除前缀 'old' 和后缀 '_no'
            return field.replace(/^old/, '').replace(/_no$/, '');
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/currencytransform') {
                        this.saveItCurrency();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        // 获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.isAdd = false;
            this.isedit = true;
            apiLastCurrency({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    }
                } else {
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiAllSelectCurrency({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_cust = res.data.cust;
                    this.pull_trans = res.data.atrans_no;
                    if (this.$route.query.isadd == 0) {
                        this.add();
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '43'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '1';
            }
            this.drawers = true;
        },

        checkMove() {},
        keycancel() {
            this.drawers = false;
            this.getTable();
            this.getTable1();
            this.getTable2();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 修改成品附加数据
        changeData(row, type) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },
        //搜索-----------------------------------------------------
        searchIt(no) {
            this.isedit = true;
            apiSearchCurrency({
                trans_no: no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    this.outData.isshow = false;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            if (no == null) {
                this.geData();
            } else {
                this.searchIt(no);
            }
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/currencytransform');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isedit == true) {
                if (this.form.check == 0) {
                    this.isedit = false;
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存修改------------------------------------------
        saveItCurrency() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                data['dtl'] = table1;
                data['check'] = this.form.check == true ? '1' : '0';
                //
                this.$load.show();
                if (this.isAdd == true) {
                    apiaddCurrency(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/currencytransform');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyCurrency(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { custcurrency: [], trans_date: '', salesman_no: '' };
                this.form.check = false;
                this.isCheck = false;
                this.isAdd = true;
                this.nullBtn = false;
                this.form.trans_date = this.$getTime();
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 1; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除产品-----------------------------------------
        delCurry() {
            this.$confirm('确定要删除该货币转换单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDelCurrency({
                        trans_no: this.form.trans_no
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            if (res.data.data == null) {
                                this.form = {};
                                this.nullBtn = true;
                            } else {
                                this.form = res.data.data;
                                if (this.form.check == 1) {
                                    this.isCheck = true;
                                } else {
                                    this.isCheck = false;
                                }
                            }
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //是否可以编辑修改(审核按钮)------------------------
        isEdit(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apicheckCurrency({
                trans_no: this.form.trans_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                    this.$message.success(res.msg);
                    this.searchIt(this.form.trans_no);
                } else {
                    this.$message.error(res.data.info);
                    this.searchIt(this.form.trans_no);
                    // if (this.form.check == 1) {
                    //     this.form.check = 0;
                    // } else {
                    //     this.form.check = 1;
                    // }
                }
            });
        },
        // 跳到第一页-------------------------------------------
        firstPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiFirstCurrency({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 跳到最后一页-------------------------------------------
        lastPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiLastCurrency({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 下一页-----------------------------------------------------
        nextPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiNextCurrency({
                trans_no: this.form.trans_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        // 上一页------------------------------------------
        prevPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrevCurrency({
                trans_no: this.form.trans_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },

        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                oldcurrency_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'oldcurrency_no');
            // this.$refs.curryfocus.focus();
        },

        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                //
                //
                this.insertEvent(-1);
                // $panel.confirmFilter()
            }
        },
        deleUser({ $panel, row }, event) {
            if (event.keyCode === 46) {
                this.$refs.xTable1.remove(row);
            }
        },
        //导出excel----------------------------------------
        showOut() {
            this.excelData.isshow = true;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        outExcel() {
            var name = this.username;
            // var that=this;
            // if(name==null){
            //     this.$message.error('未登录,请重新登录');
            //     sessionStorage.removeItem('userToken');
            //     setTimeout(() => {
            //         that.$router.push('/login');
            //     }, 1000);
            // }else{
            this.excelData.isshow = false;
            this.$axios
                .get(this.$baseURL + 'currencytrans_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        login_staff: name,
                        trans_no: this.keyword,
                        type: this.excelValue,
                        cust_no: this.cust_no,
                        oldamt: this.oldamt,
                        oldcurrency_no: this.oldcurrency_no,
                        trans_date: this.trans_date,
                        atrans_no: this.atrans_no
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '.xlsx';
                    link.click();
                });
            // }
        },
        //导出模板----------------------------------
        outTem() {
            this.$axios
                .get(this.$baseURL + 'currencytrans_template_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        type: this.excelValue
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '模板.xlsx';
                    link.click();
                });
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },

        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '39'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        countAmount(row) {
            var b = Number(row.oldamt || 0) * Number(row.rate || 0);
            row.amt = b;
            return b;
        },

        refreshs() {
            this.$forceUpdate();
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        getRefreshPull() {
            this.pull_cust = this.allArr.cust;
            this.pull_trans = this.allArr.atrans_no;
        },

        // 表尾合计-----------------------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        this.form.sumamt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'oldamt') {
                        this.form.oldamt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增入库明细
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.xTable1.getTableData().fullData.length;
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        goHistory() {
            this.$router.push({ path: '/currencyHistory', query: { page: 'currencytransform' } });
        },
        selectCust(value) {
            let item = this.pull_cust.filter((item) => item.cust_no == value);
            this.form.salesman_no = item[0].salesman_no;
        },
        handleInput(row, field, type) {
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            var jumps = ['amt']; //非输入框列字段
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;
            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);
            // 最后一列不需要右移
            if (columnIndex + 1 < length) {
                // 获取当前列的下一列
                var downtype = column[columnIndex + 1].property;
                // 不需要填写的跳过
                if (column[columnIndex + 2]) {
                    var downtypes = column[columnIndex + 2].property;
                }
            }

            // 回车键遇到非输入框需要单独处理
            if (e.keyCode == '13' || e.keyCode == '9') {
                if (jumps.indexOf(downtype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, downtype);
                }
                if (rowIndex + 1 == rows.length && columnIndex + 1 == length) {
                    this.insertEvent(-1);
                }
            }
            if (e.keyCode == '39') {
                if (jumps.indexOf(downtype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, downtypes);
                } else {
                    if (columnIndex + 1 == length) {
                        if (rowIndex + 1 == rows.length) {
                            this.insertEvent(-1);
                            rows = this.$refs.xTable1.getTableData().fullData;
                            // 换行
                            setTimeout(() => {
                                this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                            }, 100);
                        } else {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }
                        // // 换行
                        // this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    } else {
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                var uptype = column[columnIndex - 1].property;
                // 不需要填写的跳过
                if (column[columnIndex - 2]) {
                    var uptypes = column[columnIndex - 2].property;
                }

                if (jumps.indexOf(uptype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, uptypes);
                } else {
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>

<style scoped></style>
<style>
.modify {
    background: #eee;
    border-radius: 10px;
    padding-right: 20px;
}
.modify .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
.modify .el-form-item__label {
    padding: 0 0 0 0;
}
.modify .el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0;
    color: #409eff !important;
    padding: 0 0;
}
.modify .el-input.is-disabled .el-input__inner {
    background-color: #eee;
}
.checkboxProOreder {
    margin-top: 5px;
    float: right;
    margin-left: 10px;
}
.checkboxProOreder input[type='checkbox'] {
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    position: relative;
}
.checkboxProOreder input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
}
.checkboxProOreder input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #fff;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    border: 1px solid #e50232;
    color: #e50232;
    font-size: 17px;
    font-weight: bold;
}
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.accountcurrency .vxe-table .vxe-body--column.col--ellipsis,
.accountcurrency .vxe-table.vxe-editable .vxe-body--column,
.accountcurrency .vxe-table .vxe-footer--column.col--ellipsis,
.accountcurrency .vxe-table .vxe-header--column.col--ellipsis {
    height: 30px;
}
.accountcurrency .vxe-table .vxe-body--column:not(.col--ellipsis),
.accountcurrency .vxe-table .vxe-footer--column:not(.col--ellipsis),
.accountcurrency .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 5px 0;
}
.accountct {
    display: flex;
    align-items: flex-start;
}
.accountct .vxe-table.size--mini .vxe-body--column.col--ellipsis,
.accountct .vxe-table.size--mini .vxe-footer--column.col--ellipsis,
.accountct .vxe-table.size--mini .vxe-header--column.col--ellipsis,
.accountct .vxe-table.vxe-editable.size--mini .vxe-body--column {
    height: 30px;
}
.accountct .vxe-table.size--mini .vxe-body--column:not(.col--ellipsis),
.accountct .vxe-table.size--mini .vxe-footer--column:not(.col--ellipsis),
.accountct .vxe-table.size--mini .vxe-header--column:not(.col--ellipsis) {
    padding: 5px 0;
}
.accountcurrency tr.vxe-header--row:first-child {
    background: rgb(128, 0, 0);
    color: #fff;
}
.accountct div tr.vxe-header--row:first-child {
    background: rgb(64, 128, 128);
    color: #fff;
}
.overct {
    width: 100%;
}
.el-select {
    width: 100%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
<style scoped lang="scss">
.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
</style>
